import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, FormControlLabel, Checkbox } from '@mui/material';
import AddBoxOutlined from '@mui/icons-material/AddBoxOutlined';
import IndeterminateCheckBoxOutlined from '@mui/icons-material/IndeterminateCheckBoxOutlined';

import './LocationsTreeNode.scss';


/** 
 * @param {{
 *      isRoot: bool;
 *      node: LocTreeNode;
 * }} param0
 * @returns
 */
const LocationsTreeNode = ({ isRoot = false, node = {}, handleUpdateExpandable = () => { }, handleSelectNode = () => { }, handleUnselectNode = () => { } }) => {
    const handleToggleAccordion = (event, node) => {
        if (event?.target?.type === 'checkbox') {
            return;
        }

        let clickClass = event?.target?.parentNode?.className;
        if (clickClass && clickClass.includes && clickClass.includes("location-tree-node-summary-control")) {
            return;
        }

        handleUpdateExpandable(node);
    }

    const handleToggleCheckbox = (event, node) => {
        if (node.isChecked) {
            handleUnselectNode(node);
        } else {
            handleSelectNode(node);
        }
    }

    const highlightClass = node.isSearchHighlight ? "location-tree-node-search-highlight" : "";

    return (
        <>
            {
                node.isJob ? (
                    <div className='location-tree-node-job-details'>
                        <FormControlLabel
                            className={`location-tree-node-summary-control ${highlightClass}`}
                            label={node.isRoot ? node.orgPath : node.jobName}
                            control={
                                <Checkbox
                                    color="primary"
                                    className='location-tree-node-checkbox'
                                    checked={node.isSelected || (node.isChecked && !node.isIndeterminate)}
                                    indeterminate={node.isIndeterminate && node.isChecked}
                                    onChange={(e) => handleToggleCheckbox(e, node)}
                                />
                            }
                        />
                    </div>
                ) : (
                    <Accordion
                        key={node.nodeId}
                        className="location-tree-node-accordion"
                        expanded={node.isExpanded}
                        onChange={(e) => handleToggleAccordion(e, node)}
                        elevation={0}
                    >
                        <AccordionSummary
                            className='location-tree-node-accordion-summary'
                            expandIcon={node.isExpanded ? <IndeterminateCheckBoxOutlined /> : <AddBoxOutlined />}
                        >
                            <FormControlLabel
                                className={`location-tree-node-summary-control ${highlightClass}`}
                                label={node.isRoot ? node.orgPath : node.jobName}
                                control={
                                    <Checkbox
                                        className='location-tree-node-checkbox'
                                        checked={node.isSelected || (node.isChecked && !node.isIndeterminate)}
                                        indeterminate={node.isIndeterminate && node.isChecked}
                                        onChange={(e) => handleToggleCheckbox(e, node)}
                                    />
                                }
                            />
                        </AccordionSummary>
                        <AccordionDetails
                            className='location-tree-node-accordion-details'
                        >
                            {
                                (node.children && node.children.length && node.isExpanded) ? node.children.map(x =>
                                    <LocationsTreeNode
                                        key={x.nodeId}
                                        node={x}
                                        handleUpdateExpandable={handleUpdateExpandable}
                                        handleSelectNode={handleSelectNode}
                                        handleUnselectNode={handleUnselectNode}
                                    />
                                ) : null
                            }
                        </AccordionDetails>
                    </Accordion>
                )
            }

        </>

    );
}

export default LocationsTreeNode;